// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Template {\n  display: inline-block;\n  margin: 0;\n  padding: 0;\n  width: 100vw;\n  height: 100vh;\n  min-height: 100vh;\n  max-height: 100vh;\n  color: #000;\n}\n\n.TemplateContent {\n  display: inline-block;\n  width: 100vw;\n  height: calc(100vh - 50px);\n  min-height: calc(100vh - 50px);\n}", ""]);
// Exports
module.exports = exports;
